import { Field } from './field.model';
import { Link } from './link.model';

export class Asset {
  id: string;
  parentId: string;
  fileName: string;
  fileHash: string;
  isProtected: boolean;
  slug: string;
  mimeType: string;
  fileType: string;
  metadataText: string;
  metadata: object;
  tags: string[];
  fileSize: number;
  fileVersion: number;
  type: string;
  createdBy: string;
  lastModifiedBy: string;
  created: string;
  lastModified: string;
  version: number;
  isImage: boolean;
  _links: { [id: string]: Link };
  fieldName: string;

  constructor(current?: any) {
    if (current) {
      Object.assign(this, current);
    } else {
    }
  }

}
